import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

	const { loading, user, isAuth, handleLogin, handleLogout, handleLogoutDisconnect, status, statusMessage, handleStatus, handleUpdateUser } = useAuth();

	return (
		<AuthContext.Provider
			value={{ loading, user, isAuth, handleLogin, handleLogout, handleLogoutDisconnect, status, statusMessage, handleStatus, handleUpdateUser }}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
